export enum ELocalStorageKeys {
  checkoutEmail = "checkoutEmail",
  checkoutIrn = "checkoutIrn",
}
